import React, { useEffect } from "react";
import { Dashboard } from "../../components/UserDashboard/Dashboard";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { useIntl } from "react-intl";

const UserDashboard = () => {
  const navigate = useNavigate();
  const intl = useIntl();

  useEffect(() => {
    const auth = localStorage.getItem("userData");
    if (!auth) {
      message.error(intl.formatMessage({ id: "please_login_first", defaultMessage: "Please login first to access the dashboard" }), 3);
      navigate("/", { replace: true });
    }
  }, [navigate, intl]);

  const auth = localStorage.getItem("userData");
  if (!auth) {
    return null;
  }

  return (
    <>
      <div className="header-wrapper" style={{ position: "relative", marginBottom: "-60px" }}>
        <Header />
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            height: "81px",
            position: "fixed",
            top: "0px",
            width: "100%",
            zIndex: 1,
          }}
        ></div>
        <Dashboard />
      </div>
    </>
  );
};

export default UserDashboard;
